import { RouteRecordRaw } from "vue-router";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "login",
    component: () => import("@/modules/Auth/views/Login.vue"),
  },
  {
    path: PATH.SIGNUP,
    name: "signup",
    component: () => import("@/modules/Auth/views/Signup.vue"),
  },
  {
    path: PATH.FORGOT_PASSWORD,
    name: "forgotPassword",
    component: () => import("@/modules/Auth/views/ForgotPassword.vue"),
  },
  {
    path: PATH.RESET_PASSWORD,
    name: "resetPassword",
    component: () => import("@/modules/Auth/views/ResetPassword.vue"),
  },
  {
    path: PATH.DISABLE_MFA,
    name: "disableMfa",
    component: () => import("@/modules/Auth/views/DisableMfa.vue"),
    meta: {
      allowAuthenticated: true,
    },
  },
  {
    path: PATH.DOWNLOAD_VISA_VERIFICATION,
    name: "downloadVisaVerificationPDF",
    component: () =>
      import("@/modules/VisaVerification/views/DownloadVisaVerification.vue"),
  },
];

export default routes;
